import {
  Goal,
  ID,
  LifeArea,
  SortingMode,
  Task,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { buildLifeAreaTree } from '@griply/utils';
import { useMemo } from 'react';
import { useEntityLinks } from 'shared/hooks/use-entity-links';

export { filterEmptyChildrenCascading } from '@griply/utils';

export type Options = {
  lifeAreas: LifeArea[];
  goals: Goal[];
  tasks: Task[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  showEmptyGroups?: boolean;
  hideNewTaskRow?: boolean;
};

export const useLifeAreaTree = ({
  lifeAreas,
  goals,
  tasks,
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  showEmptyGroups,
  hideNewTaskRow,
}: Options) => {
  const links = useEntityLinks();

  return useMemo<Record<ID, TaskListTreeItem>>(
    () =>
      buildLifeAreaTree({
        lifeAreas,
        goals,
        tasks,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        showEmptyGroups,
        hideNewTaskRow,
        otherLifeAreaLabel: 'Other',
        rootLabel: 'Root',
        newTaskLabel: 'New Task',
        links,
      }),
    [
      customOrder,
      goals,
      links,
      lifeAreas,
      sortingMode,
      tasks,
      today,
      weekStartsOn,
      showEmptyGroups,
      hideNewTaskRow,
    ],
  );
};
